import React from "react";
import { motion } from "framer-motion";
import { LuxuryBackground, PageHero } from "../components/shared/UIComponents";

export default function RiskDisclosurePage() {
  return (
    <div className="relative" data-testid="risk-disclosure-page">
      <PageHero eyebrow="Legal" title="Risk Disclosure" description="Please review the following risk factors carefully before participating in any transaction." />
      <div className="relative">
        <LuxuryBackground />
        <article className="relative z-10 mx-auto max-w-4xl px-4 py-10 sm:px-6 sm:py-16 lg:px-8">
          <div className="rounded-3xl border border-cream-warm bg-white p-8 md:p-12 shadow-sm space-y-8 text-[#333] text-sm leading-7">

            <section>
              <p>Participation in real estate lending opportunities and related financial transactions involves substantial risk. Users of the Imaani Capital platform should carefully review the following risk factors before participating in any transaction, investment opportunity, or capital deployment activity.</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[#0A0A0A] mb-4">General Investment Risk</h2>
              <p>Investments in private real estate debt and real estate-backed financing opportunities involve significant risks, including the potential loss of some or all invested capital. These investments are not insured or guaranteed by any government agency, bank, or financial institution.</p>
              <p className="mt-3">Individuals should only participate in such opportunities if they fully understand the associated risks and are financially able to withstand the potential loss of their investment.</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[#0A0A0A] mb-4">No Guarantee of Performance</h2>
              <p>Imaani Capital makes no representation or guarantee regarding the performance of any investment opportunity, borrower repayment, projected yield, expected returns, or financial outcomes.</p>
              <p className="mt-3">Any financial projections, yield estimates, or performance assumptions presented through the platform are forward-looking statements based on assumptions that may change.</p>
              <p className="mt-3">Actual results may differ materially due to economic conditions, borrower performance, real estate market fluctuations, interest rate changes, construction delays, operational risks, or other factors beyond the control of the platform.</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[#0A0A0A] mb-4">Illiquidity of Investments</h2>
              <p>Opportunities presented through the Imaani Capital platform may involve private real estate lending transactions that are illiquid in nature. Investors may not be able to sell, transfer, or redeem their investment prior to the completion of the underlying loan or project.</p>
              <p className="mt-3">Participants should be prepared to hold investments for the full duration of the investment term.</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[#0A0A0A] mb-4">Borrower Credit and Default Risk</h2>
              <p>Investment opportunities depend on the financial performance and repayment ability of borrowers. If a borrower defaults or fails to meet financial obligations, investors may experience delayed payments, reduced returns, or loss of principal.</p>
              <p className="mt-3">In the event of borrower default, recovery processes may involve legal proceedings, collateral liquidation, or other enforcement actions that may take significant time and may not result in full recovery of invested capital.</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[#0A0A0A] mb-4">Real Estate Market Risk</h2>
              <p>Real estate markets are subject to fluctuations influenced by economic conditions, interest rate movements, supply and demand dynamics, regulatory changes, and local market factors.</p>
              <p className="mt-3">Changes in these conditions may affect property values, borrower exit strategies, refinancing ability, or asset liquidity.</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[#0A0A0A] mb-4">Platform Role and Limitations</h2>
              <p>Imaani Capital operates as a technology platform and capital marketplace that facilitates connections between borrowers, lenders, and capital participants.</p>
              <p className="mt-3">Unless explicitly stated in written agreements, Imaani Capital does not:</p>
              <ul className="list-disc ml-6 mt-3 space-y-2">
                <li>act as an investment advisor</li>
                <li>provide financial or investment advice</li>
                <li>guarantee loan performance</li>
                <li>guarantee financing outcomes</li>
              </ul>
              <p className="mt-3">Users are responsible for conducting their own due diligence and making independent financial decisions.</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[#0A0A0A] mb-4">Information Accuracy</h2>
              <p>Information presented on the platform may be provided by borrowers, lenders, or third-party sources. While efforts may be made to organize and present information clearly, Imaani Capital does not guarantee the completeness or accuracy of third-party data.</p>
              <p className="mt-3">Participants should independently verify any information before making financial decisions.</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[#0A0A0A] mb-4">Regulatory Considerations</h2>
              <p>Certain investment opportunities presented through the platform may be offered under exemptions from securities registration under applicable securities laws. These offerings may not be subject to the same disclosure requirements as publicly registered securities.</p>
              <p className="mt-3">Participants should carefully review offering documentation and consult professional advisors.</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[#0A0A0A] mb-4">Professional Advice</h2>
              <p>Users of the Imaani Capital platform are encouraged to consult with qualified legal, financial, and tax advisors before participating in any investment or financing activity.</p>
            </section>

          </div>
        </article>
      </div>
    </div>
  );
}
